/* SNR: kaartfoto's swipen. Mobiel: native swipe. Desktop: slepen met de muis. Werkt ook na filteren. */
(function () {
  if (window.snrCardSwipe) return;
  window.snrCardSwipe = true;

  function update(el) {
    var i = Math.round(el.scrollLeft / (el.clientWidth || 1));
    var n = el.children.length;
    var dots = el.parentNode.querySelectorAll('.snr-cs-dots span');
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
    var prev = el.parentNode.querySelector('.snr-cs-arrow--prev');
    var next = el.parentNode.querySelector('.snr-cs-arrow--next');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }

  var ticking = false;
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('snr-cs') || ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(el); });
  }, true);

  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!fine) return;

  function arm(el) {
    if (el.dataset.snrArmed) return;
    el.dataset.snrArmed = '1';
    update(el);

    /* slepen met de muis */
    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (!moved) return;
      var w = el.clientWidth || 1;
      var delta = (el.scrollLeft - startLeft) / w;
      var base = Math.round(startLeft / w);
      var target = base + (delta > 0.15 ? 1 : delta < -0.15 ? -1 : 0);
      target = Math.max(0, Math.min(el.children.length - 1, target));
      el.classList.remove('is-dragging');
      el.scrollTo({ left: target * w, behavior: 'smooth' });
    });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* na slepen geen klik op de link */
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function scan(root) {
    var list = (root || document).querySelectorAll ? (root || document).querySelectorAll('.snr-cs') : [];
    for (var i = 0; i < list.length; i++) arm(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  new MutationObserver(function (muts) {
    for (var m = 0; m < muts.length; m++) {
      var added = muts[m].addedNodes;
      for (var a = 0; a < added.length; a++) if (added[a].nodeType === 1) scan(added[a].parentNode || added[a]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
